module.exports = __webpack_public_path__ + "static/media/macbook-pro-past-shoots.106b90ce.png";